export default __webpack_public_path__ + "static/media/MicrosoftResearch.3087f430.png";